/* @refresh reload */
import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";
import "./lib/tokens/tokens.css";
import "./lib/tokens/base.css";
import "./components/AplombButton.css";
import "./components/AplombField.css";
import "./components/AplombChip.css";
import "./components/AplombScoreBadge.css";

import Landing from "./routes/index";
import Urgence from "./routes/urgence";
import Match from "./routes/match/[id]";
import ProSignup from "./routes/pro/signup";
import Login from "./routes/login/index";
import { initObservability } from "./lib/observability";

// Observability init — no-op si DSN/KEY absents (dev local).
initObservability().catch(() => void 0);

const root = document.getElementById("app");
if (!root) {
  throw new Error("Aplomb : root element #app introuvable");
}

render(
  () => (
    <Router>
      <Route path="/" component={Landing} />
      <Route path="/urgence" component={Urgence} />
      <Route path="/match/:id" component={Match} />
      <Route path="/pro/signup" component={ProSignup} />
      <Route path="/login" component={Login} />
    </Router>
  ),
  root,
);
